import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createTheme, ThemeProvider } from "mineral-ui/themes";
import { StripeProvider } from "react-stripe-elements";
import "./index.css";
import App from "./App";

const client = new ApolloClient({
  link: new HttpLink({
    credentials: "same-origin",
  }),
  cache: new InMemoryCache({
    dataIdFromObject: object => object.nodeId,
  }),
});
const myTheme = createTheme({ colors: { theme: "slate" } });

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <ThemeProvider theme={myTheme}>
        <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}>
          <App />
        </StripeProvider>
      </ThemeProvider>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById("root")
);
